export const semiBold = ({ fontWeight = 600 } = {}) => `
    font-family: "Open sans", sans-serif;
    font-weight: ${fontWeight};
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  `;
